import { Pipe, PipeTransform } from '@angular/core';

import { oms } from 'src/app/core/models/models.generated';

import { AmountPipe } from '@bayclubs/utils';

export type FeeAmountType = 'totalValue' | 'netAmountToBePaid' | 'promotionOnly';

@Pipe({
    name: 'feeAmount',
    standalone: false
})
export class FeeAmountPipe implements PipeTransform {
    constructor(private amountPipe: AmountPipe) {}

    transform(fees: oms.AppliedFeeModel[], code?: string, amountType: FeeAmountType = 'netAmountToBePaid', showZeroIfEmpty: boolean = false): any {
        const fee = fees?.find(fee => fee.code === code);
        if (!fee) {
            return showZeroIfEmpty ? this.amountPipe.transform('0', 2) : null;
        };

        const fractionDigits = 2;

        switch (amountType) {
            case 'totalValue':
                return this.amountPipe.transform(fee.totalValue.toString(), fractionDigits);
            case 'netAmountToBePaid':
                return this.amountPipe.transform(fee.netAmountToBePaid.toString(), fractionDigits);
            case 'promotionOnly':
                return fee.hasPromotion ? this.amountPipe.transform(fee.netAmountToBePaid.toString(), fractionDigits) : null;
            default:
                return this.amountPipe.transform(fee.netAmountToBePaid.toString(), fractionDigits);
        }
    }
}
